import {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
} from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

const SelectWithIcon = ({
    value,
    onChange,
    options,
    btnClass,
    chevronClass,
}) => {
    const selected = options.find(opt => opt.value === value);

    return (
        <Listbox value={value} onChange={onChange}>
            <div className="relative">
                <ListboxButton
                    className={`relative group w-full cursor-default rounded-md bg-white py-[10px] pl-3 pr-10 text-left text-gray-900 ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-700 sm:leading-6 ${btnClass}`}
                >
                    <span className="flex items-center">
                        {!!selected?.icon && (
                            <div className="h-5 w-5 flex-shrink-0 mr-3">
                                {selected?.icon}
                            </div>
                        )}
                        <span className="block truncate">
                            {selected?.name || <span>&nbsp;</span>}
                        </span>
                    </span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                        <ChevronUpDownIcon
                            aria-hidden="true"
                            className={`h-5 w-5 text-gray-400 ${chevronClass}`}
                        />
                    </span>
                </ListboxButton>

                <ListboxOptions
                    transition
                    className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                    modal={false}
                >
                    {options.map((opt, idx) => (
                        <ListboxOption
                            key={idx}
                            value={opt.value}
                            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-gray-200"
                        >
                            <div className="flex items-center">
                                {!!opt.icon && (
                                    <div className="h-5 w-5 flex-shrink-0 mr-3">
                                        {opt.icon}
                                    </div>
                                )}

                                <span className="block truncate font-normal">
                                    {opt.name}
                                </span>
                            </div>

                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-black [.group:not([data-selected])_&]:hidden">
                                <CheckIcon
                                    aria-hidden="true"
                                    className="h-5 w-5"
                                />
                            </span>
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </div>
        </Listbox>
    );
};

export default SelectWithIcon;
